import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '../../../components/atoms/PrimaryButton'
import SecondaryButton from '../../../components/atoms/SecondaryButton'
import FullScreenPopup from '../../../components/organisms/FullScreenPopup'
import { mapData, handleRedirectInternal } from '../../../common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import SettingContext from '../../../context/setting/settingContext'
import { useLocation } from 'react-router-dom'

const TemplateManage = (props) => {
    const search = useLocation().search
    const edit = new URLSearchParams(search).get('edit')

    const settingContext = useContext(SettingContext)

    const {
        single_configuration,
        getSingleConfiguration,
        configurationAction,
    } = settingContext

    const data = props.data
    const toggleFullScreenPopup = props.function

    const [reload, setReload] = useState(false)

    const validationArray = Yup.object({
        variable: Yup.string().required('Required!'),
        question: Yup.string().required('Required!'),
        type: Yup.string().required('Required!'),
        value: Yup.string().when('type', {
            is: (type) => type !== 'uploadDropZone',
            then: Yup.string().required('Required!'),
            otherwise: Yup.string(),
        }),
        value_array: Yup.string().when('type', {
            is: (type) => type === 'uploadDropZone',
            then: Yup.string().required('Required!'),
            otherwise: Yup.string(),
        }),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            value: '',
            value_array: [],
            type: '',
            question: '',
            variable: '',
            enabled: 1,
        },
        validationSchema: validationArray,
        // validateOnBlur: false,
        enableReinitialize: true,
        onSubmit: (values) => {
            if (values.type === 'uploadDropZone') {
                values.value = values.value_array
            }
            configurationAction(values)
        },
    })

    // useEffect(() => {
    //     resetFrom()
    // }, [props])

    const resetFrom = () => {
        formik.setFieldValue('id', 0)
        formik.setFieldValue('value', '')
        formik.setFieldValue('value_array', [])
        formik.setFieldValue('type', '')
        formik.setFieldValue('question', '')
        formik.setFieldValue('variable', '')
        formik.setFieldValue('enabled', 1)
        formik.handleReset()
        formik.resetForm()
        setReload(!reload)
    }

    useEffect(() => {
        if (data.status === 'edit') {
            formik.values.id = data.id
            getSingleConfiguration(formik.values)
        } else {
            resetFrom()
        }
    }, [data.id])

    useEffect(() => {
        if (single_configuration.record && data.status === 'edit') {
            const template = single_configuration.record
            formik.setFieldValue('id', template.id)
            formik.setFieldValue('type', template.type || '')
            formik.setFieldValue('question', template.question || '')
            formik.setFieldValue('variable', template.variable || '')

            if (template.type === 'checkbox') {
                formik.setFieldValue(
                    'value',
                    template.value === '1' ? true : false
                )
                formik.setFieldValue('value_array', [])
            } else if (template.type === 'uploadDropZone') {
                formik.setFieldValue('value', '')
                formik.setFieldValue(
                    'value_array',
                    template.value.toString().split(',')
                )
            } else {
                formik.setFieldValue('value', template.value)
                formik.setFieldValue('value_array', [])
            }
            formik.setFieldValue('enabled', template.enabled || 1)
        }
        setReload(!reload)
    }, [single_configuration])

    const emailTemplate = {
        formik: formik,
        data: [
            {
                label: 'Variable',
                placeholder: 'Enter Variable',
                class: 'col-12 mb-4',
                disabled: data.status === 'new' || edit === '1' ? false : true,
                type: 'text',
                shrink: true,
                name: 'variable',
            },
            {
                label: 'Question',
                placeholder: 'Enter Question',
                class: 'col-12 mb-4',
                disabled: data.status === 'new' || edit === '1' ? false : true,
                type: 'text',
                shrink: true,
                name: 'question',
            },
            {
                label: 'Type',
                placeholder: 'Enter type',
                class: 'col-12 mb-4',
                disabled: data.status === 'new' || edit === '1' ? false : true,
                type: 'select',
                options: [
                    { value: 'checkbox', show: 'Checkbox' },
                    { value: 'text', show: 'Text' },
                    { value: 'number', show: 'Number' },
                    { value: 'float', show: 'Decimal' },
                    { value: 'uploadDropZone', show: 'Image' },
                ],
                name: 'type',
            },
            {
                label: formik.values.question
                    ? formik.values.question
                    : 'Value *',
                placeholder: `Enter ${
                    formik.values.question ? formik.values.question : 'Value'
                }`,
                class: `${
                    formik.values.type !== 'uploadDropZone'
                        ? 'col-12'
                        : 'd-none'
                }`,
                name: 'value',
                type:
                    formik.values.type &&
                    formik.values.type !== 'uploadDropZone'
                        ? formik.values.type
                        : '',
            },
            {
                label: formik.values.question
                    ? formik.values.question
                    : 'Value *',
                titleText: formik.values.question
                    ? formik.values.question?.includes('Banner')
                        ? 'Add a banner image with aspect ratio of 12:5'
                        : formik.values.question
                    : 'Value',
                class: `${
                    formik.values.type === 'uploadDropZone'
                        ? 'col-12'
                        : 'd-none'
                }`,
                name: 'value_array',
                type:
                    formik.values.type &&
                    formik.values.type === 'uploadDropZone'
                        ? formik.values.type
                        : '',
                multiple: false,
                folder: 'config',
            },
        ],
    }

    return (
        <>
            {reload}
            <FullScreenPopup
                modaltitle={
                    data.status === 'new'
                        ? 'ADD CONFIGURATION'
                        : `EDIT CONFIGURATION: ${formik.values.variable}`
                }
                open={data.popup}
                handleClose={() => toggleFullScreenPopup(false)}
            >
                <div className="addUserModal">
                    <div className="fspBody">
                        <form autoComplete="nofill">
                            <div className="row">
                                {Object.values(mapData(emailTemplate))}
                            </div>

                            <div className="actionButton d-flex justify-content-center align-items-center">
                                <SecondaryButton
                                    id="configure_cancel"
                                    label="Cancel"
                                    onClick={() => toggleFullScreenPopup(false)}
                                />
                                <PrimaryButton
                                    id="config_submit"
                                    label="Submit"
                                    onClick={formik.handleSubmit}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </FullScreenPopup>
        </>
    )
}

export default TemplateManage
